import { apiSlice } from "../apiSlice";
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
interface IssueOrderRequest {
    orderId: string;
    paymentMethod: string;
    groupOrderId: string;
    liveLocation: {
        longitude: number;
        latitude: number;
    }
    reason: string;
}

interface IssueOrderResponse {
    // success: boolean;
    message: string;
}

export const orderService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        issueOrder: builder.mutation<IssueOrderResponse, IssueOrderRequest>({
            query: (data) => ({
                // url: `https://adminhttps-issueorder${API_BASE_DOMAIN}`,
                url: `https://adminhttps-issueordertocustomer${API_BASE_DOMAIN}`,
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/json",
                },
                responseHandler: (response) => response.text(),
            }),
        }),
    }),
});

export const { useIssueOrderMutation } = orderService;